import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { sendToVercelAnalytics } from "./vitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/state/state";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProviderWrapper } from "./Themes/ThemeProviderWrapper";

ReactDOM.render(
 
    <BrowserRouter>
      <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProviderWrapper>
          <App />
          </ThemeProviderWrapper>
          </PersistGate>
      </Provider>
    </BrowserRouter>
,
  document.getElementById("root")
);

reportWebVitals(sendToVercelAnalytics);
